var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contentRight2"},[_c('div',{staticClass:"rightHead"},[(_vm.$route.meta.titleShow)?_c('div',{staticStyle:{"margin":"0 0 0 30px","font-size":"15px","padding-top":"16px","color":"#707070"}},[_vm._v(_vm._s(_vm.$route.name))]):_vm._e()]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f799affc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/invoicingFather.vue
// module id = null
// module chunks = 